import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import HeaderDropdown from './ui/HeaderDropdown';

const PriceToggle = () => {
    const priceToggle = useTypedSelector((state) => state.priceToggle);
    const { currentType, availableTypes } = priceToggle;

    if (availableTypes.length === 0) {
      return null;
    }
    
    return (
    <div className="price-toggle__wrapper">
      <HeaderDropdown 
        options={availableTypes}
        selectedOption={currentType}
      />
    </div>
  );
}

export default PriceToggle;